<template>
  <div id="app">
	
	<header v-if="is_pc">
		<div class="header_left" style="margin-top: -25px; margin-left: -30px;">
			<img src="./assets/image/logo.png" height="165px" alt="府右集团" title="府右集团" />
		</div>
		<div class="header_right">
			<div class="header_right_nav"><a :href="urlPrefix + '#/contact'" class="a_795B">联系我们<br/><span>Contact</span></a></div>
			<div class="header_right_nav"><a :href="urlPrefix + '#/team'" class="a_795B">管理团队<br/><span>Team</span></a></div>
			<div class="header_right_nav"><a :href="urlPrefix + '#/portfolio'" class="a_795B">业务版图<br/><span>Portfolio</span></a></div>
			<div class="header_right_nav"><a :href="urlPrefix" class="a_795B">集团简介<br/><span>Fulright</span></a></div>
		</div>
	</header>
	
	<header v-if="is_mobile" @click="showPop" style="margin-top: 0px; background-color: #000; border-radius: 0px;">
		<img src="./assets/image/logo.png" height="80px" style="float: left; margin-left: -10px; margin-top: -7px;" />
		<van-icon name="apps-o" style="float: right; margin-top: 18px; margin-right: 8px;" size="22" color="#fff" />
	</header>
	
	<keep-alive>
		<router-view></router-view>
	</keep-alive>
	
	<footer v-if="is_pc">
		&copy;2020 北京府右控股集团有限公司 Beijing Fulright Holdings Group 京ICP备20031155号
		<img src="./assets/image/logo-yinzhang.png" height="65px" style="margin-top: -60px; margin-bottom: -40px;" />
		<br/>
		<a :href="urlPrefix" class="a_dedede">集团简介</a> |
		<a :href="urlPrefix + '#/portfolio'" class="a_dedede">业务版图</a> | 
		<a :href="urlPrefix + '#/team'" class="a_dedede">管理团队</a> | 
		<a :href="urlPrefix + '#/contact'" class="a_dedede">联系我们</a>
		<br/>
		
	</footer>
	
	<footer v-if="is_mobile" style="height: 50px; color: #fff; line-height: 20px; background-color: #000; padding: 0px 0px 0px 0px;">
		&copy;2020 北京府右控股集团有限公司 
		<br/>Beijing Fulright Holdings Group 
		<br/>京ICP备20031155号
		<br/>
		<img src="./assets/image/logo-yinzhang.png" height="50px" style="float: right; margin-top: -55px; margin-right: 40px;" />
	</footer>
	
	<van-popup
		v-model="popShow"
		position="top"
		:style="{ height: '225px', background: '#dedede'}"
		>
		<div class="main_menu" @click="toUrl('#/mobi')" style="margin-top: 60px;">·集团简介 Fulright</div>
		<div class="main_menu" @click="toUrl('#/portfolio_mobi')" >·业务版图 Portfolio</div>
		<div class="main_menu" @click="toUrl('#/team_mobi')" >·管理团队 Team</div>
		<div class="main_menu" @click="toUrl('#/contact_mobi')" >·联系我们 Contact</div>
	</van-popup>
	
  </div>
</template>

<script>
export default {
	name: 'app',
	data(){
		return{
			//urlPrefix: 'http://www.sdhaizhiyou.com/camtessential.org/'
			urlPrefix: '',
			is_pc: false,
			is_mobile: false,
			popShow: false,
		}
	},
	mounted() {
		if(this._isMobile()){//移动设备浏览
			this.is_pc = false;
			this.is_mobile = true;
		}else{//PC浏览
			this.is_pc = true;
			this.is_mobile = false;
		}
	},
	methods: {
		
		toUrl(url){
			this.popShow = false;
			//console.log(url);
			location.href = this.urlPrefix + url;
		},
		
		showPop() {
			this.popShow = true;
		},
		
		_isMobile() {
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
			//window.console.log(flag);
			return flag;
		},
		
	}
	
}
</script>

<style>
@import url("assets/css/def_main.css");
@import url("assets/css/el_css.css");
.nav-item{
	font-size: 15px;
	font-weight: 400;
	margin-top: 15px;
	padding-left: 20px;
	padding-right: 15px;
	float: left;
}
</style>
